import React from "react";
import { ArchivedDocumentWithDetails, WeightReportLineDetails } from "@/types";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";
import Accordion from "@/components/atoms/accordions/DrawerAccordion";
import Group from "@/components/atoms/Group";
import Text from "@/components/atoms/Text";
import { useGetDocumentDetailsById } from "@/services/Documents";
import { useWeightReportDetails } from "@/services/WeightReports";
import DocumentList from "@/components/molecules/DocumentList";

interface WeightReportDocumentTabProps {
  selectedWeightLine: WeightReportLineDetails;
}

const WeightReportDocumentTab: React.FC<WeightReportDocumentTabProps> = ({ selectedWeightLine }) => {
  const { t } = useTranslation();
  const { currentCompany } = useAuth();

  const { data: weightReportDetails } = useWeightReportDetails(selectedWeightLine.weightReportImportId as number, {
    enabled: !!selectedWeightLine.weightReportImportId,
  });

  const {
    data: documentDetails,
    isLoading: isLoadingDocumentDetails,
    isError,
  } = useGetDocumentDetailsById(currentCompany?.companyId as number, weightReportDetails?.documentArchiveId as string, {
    enabled: !!weightReportDetails?.documentArchiveId && !!currentCompany?.companyId,
  });

  const AccordionItems = [
    {
      value: "attachments" as const,
      label: t("weightReports:weightReportDocument"),
      controller: (
        <Accordion.Control>
          <Group>
            <Text size="sm" display="technical" tt="uppercase" strong={true}>
              {t("weightReports:weightReportDocument")}
            </Text>
          </Group>
        </Accordion.Control>
      ),
      panel: (
        <Accordion.Panel>
          {!isLoadingDocumentDetails && !!documentDetails ? (
            <DocumentList
              files={[documentDetails] as ArchivedDocumentWithDetails[]}
              origin={"api"}
              isLoading={isLoadingDocumentDetails}
              isError={isError}
            />
          ) : (
            <Text>{t("common:noAttachmentsFound")}</Text>
          )}
        </Accordion.Panel>
      ),
    },
  ];
  return (
    <Accordion unstyled defaultValue={AccordionItems[0]?.value}>
      {AccordionItems.map((item, index) => (
        <Accordion.Item value={item?.value} key={index}>
          {item.controller}
          {item.panel}
        </Accordion.Item>
      ))}
    </Accordion>
  );
};

export default WeightReportDocumentTab;
